// Lucide icon: arrow-down-wide-narrow (https://lucide.dev/icons/arrow-down-wide-narrow)
import { ArrowDownWideNarrow } from 'lucide-react'

import { IconComponentStyled } from '../styles/IconComponentStyled'
import { type IIconComponentProps } from '../types'

export const IconSortDescending = (props: IIconComponentProps) => {
  return (
    <IconComponentStyled {...props}>
      <ArrowDownWideNarrow />
    </IconComponentStyled>
  )
}
